<template>
  <v-container>
    <template v-if="turnStarted">
      <CardWithButtons :gameId="gameId" :playerKey="playerKey" />
    </template>
    <template v-else-if="turnEnded">
      <CurrentTurnWords :gameId="gameId" />
      <v-btn @click="nextPlayer">Continue</v-btn>
    </template>
    <template v-else>
      <v-btn @click="startturn">Start Turn</v-btn>
    </template>
  </v-container>
</template>

<script>
// @ is an alias to /src
import CardWithButtons from "./CardWithButtons.vue";
import CurrentTurnWords from "./CurrentTurnWords";
import game_play from "./firebase/game_play";

export default {
  name: "CurrentPlayerView",
  props: {
    gameId: String,
    playerKey: String,
  },
  components: {
    CardWithButtons,
    CurrentTurnWords,
  },
  created() {
    this.$root.$once("end-turn", () => {
      console.log("changing current player vars for view");
      this.turnEnded = true;
      this.turnStarted = false;
    });
  },
  methods: {
    async startturn() {
      await game_play.setTimer(this.gameId);
      this.turnStarted = true;
    },
    async nextPlayer() {
      await game_play.nextPlayer(this.gameId);
    },
  },
  data() {
    return {
      turnStarted: false,
      turnEnded: false,
    };
  },
};
</script>
